import styled from 'styled-components';

export const ContainerLoja = styled.div`
  width: 100%;
  padding: 0 1.5rem;
`;

export const ContentLoja = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 1.5rem;
  padding: 20px 0;
  width: 100%;
`;

export const SettingsCard = styled.div`
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  height: 100%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 1rem;

  h3 {
    font-size: 1rem;
    font-weight: 700;
    color: #1e293b;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin: 0;
  }
  svg {
    color: #3b82f6;
    font-size: 1.2rem;
  }
`;

export const ToggleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f1f5f9;

  &:last-child {
    border-bottom: none;
  }

  .info {
    display: flex;
    flex-direction: column;
    max-width: 80%;

    label {
      font-weight: 600;
      font-size: 0.9rem;
      color: #334155;
      margin: 0;
    }
    span {
      font-size: 0.75rem;
      color: #94a3b8;
      line-height: 1.3;
      margin-top: 2px;
    }
  }
`;

export const LojaInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;

  label {
    font-size: 0.85rem;
    font-weight: 600;
    color: #475569;
  }
`;

export const ImageUploadWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem 0;
  border-bottom: 1px solid #f1f5f9;
`;

export const ColorPickerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 8px 0;

  input[type='color'] {
    -webkit-appearance: none;
    border: none;
    margin-top: 0.2rem;
    width: 45px;
    height: 45px;
    border-radius: 8px;
    cursor: pointer;
    padding: 0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s;

    &:hover {
      transform: scale(1.05);
    }

    &::-webkit-color-swatch-wrapper {
      padding: 0;
    }
    &::-webkit-color-swatch {
      border: none;
      border-radius: 8px;
    }
  }
`;
